<template>
  <main class="home">
    <h2>Elsinore Water Share</h2>
    <h3>Water Share</h3>
    <p v-if="waterShortage" class="alert">Due to water shortages there are no current water orders scheduled.</p>
    <nav>
      <router-link to="/participants" class="button">View Participants</router-link>
      <router-link to="/schedules" class="button">View Schedules</router-link>
    </nav>
    <h3>Other Reports</h3>
    <nav>
      <router-link to="/gate-orders" class="button">View Gate Orders</router-link>
    </nav>
  </main>
</template>

<script>
export default {
  data() {
    return {
      waterShortage: false,
    }
  }
}
</script>

<style scoped>
.home {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100vh;
  margin-bottom: 100vh;
}

h2, h3 {
  text-align: center;
}

nav {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.alert {
  display: inline-block;
  padding: 15px 30px;
  background-color: maroon;
  color: white;
  text-align: center;
  border-radius: 5px;
}

</style>